import React, { useState, useEffect } from "react"
import '../../assets/css/views/activities/servedClients.css'
import { useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Modal, ButtonGroup, TextArea, Card, RadioButtons, RadioButton, IconChevronDown, ListItem, TextBox } from "@veneer/core";
import { useSelector } from "react-redux";
import { RootState } from "../../app/store";
import BackButton from "../../features/path/backButton";
import { BreadCrumbsEnum } from "../../models/enum/BreadCrumbsEnum";
import servedClientsService from "../../services/agendaApi/servedClients.service";
import { IServedClientDto } from "../../models/dto/agendaApi/IServecClientDto";
import { NumberFormatBase } from 'react-number-format';
import { IServedClientsDetails, IServedClientsIn } from "../../models/input/generalApi/IServedClientsIn";




export default function ServedClients() {

  const params = useParams();
  const [t] = useTranslation("global");
  const languageId: any = useSelector((state: RootState) => state.languageId);
  type SelectValue = number | string | boolean; //CHECK
  const navigate = useNavigate();

  //Data
  const [appointmentActivityId, setAppointmentActivityId] = useState(NaN);
  const [activityId, setActivityId] = useState(NaN);
  const [servedClientsData, setServedClientsData] = useState<IServedClientDto[]>([]);
  const [saveDisable, setSaveDisable] = useState(true);
  let servedClientsDataConst : IServedClientDto[] = [];



  useEffect(() => {
    let id = Number(params.id);
    let activityId = Number(params.activityId);
    setActivityId(id)
    setAppointmentActivityId(activityId);
    getServedClientsCategories(activityId);
  }, [])

  useEffect(() => {
    if (servedClientsData.some(item => Number.isNaN(item.quantity))) {
      setSaveDisable(true)
    } else {
      setSaveDisable(false)
    }
  }, [servedClientsData])


  const getServedClientsCategories = (activityId:number) => {
    servedClientsService.getWinRateCategories(languageId.value).then(r => {
      const datafiltered = r.filter((item:any) => item.categoryID !== 44 && item.categoryID !== 45);
      fillServedClientsDataCategories(datafiltered);
    }).then(() => getServedClients(activityId));
  }

  const getServedClients = (appointmentActivity: number) => {
    servedClientsService.getWinRate(appointmentActivity, languageId.value).then(r => {
      fillServedClientsData(r)
    });
  }


  const fillServedClientsDataCategories = (data: IServedClientDto[]) => {
    const servedClientsTemp: IServedClientDto[] = [];
    for (let i = 0; i < data.length; i++) {
      const servedClient: IServedClientDto = data[i];
      servedClientsTemp.push({
        categoryID: servedClient.categoryID,
        category: servedClient.category,
        quantity: 0
      })
    }
    setServedClientsData(servedClientsTemp)
    servedClientsDataConst = servedClientsTemp;
  }

  const fillServedClientsData = (data: IServedClientDto[]) => {
    const updatedData = servedClientsDataConst;
    for(let i = 0; i < data.length; i++){
      if(updatedData.some(item => item.categoryID === data[i].categoryID)){
        let index = updatedData.findIndex(item => item.categoryID === data[i].categoryID)
        updatedData[index].quantity = data[i].quantity;
      }
    }
    setServedClientsData([...updatedData]);
  }

  const handleChangeQuantity = (index: number, value: string) => {
    const updatedData = servedClientsData;
    updatedData[index].quantity = Number(value);
    setServedClientsData([...updatedData]);
  }

  const onSaveServedClients = () => {
    let date = new Date();
    let servedClientsDetailsTempIn: IServedClientsDetails[] = [];

    for (let i = 0; i < servedClientsData.length; i++) {
      servedClientsDetailsTempIn.push({
        categoryID: servedClientsData[i].categoryID,
        quantity: servedClientsData[i].quantity!
      })
    }

    let servedClientIn: IServedClientsIn = {
      appointmentActivityID: appointmentActivityId,
      date: date.toISOString(),
      winRateDetails: servedClientsDetailsTempIn
    };

    servedClientsService.insertServedClients(servedClientIn)
      .then(r => {
        setServedClientsData([])
        getServedClientsCategories(appointmentActivityId);
      })

  }


  return (
    <>
      <div className="servedClients">
        <BackButton route={BreadCrumbsEnum.ServedClients} activityId={activityId} appointmentActivityId={appointmentActivityId} />
        <h4 className="servedClientsTittle">{t("header.servedClientsTittle")}</h4>

        <Card
          appearance="outlined"
          className="servedClientsCard"
          content={<>
            {
              servedClientsData.map((item, index) => {
                return (
                  <ListItem
                    key={index}
                    centerArea={item.category}
                    trailingArea={
                      <TextBox
                        id={index+"servedClientstextfield"}
                        className="servedClientstextfield"
                        type="number"
                        label={t("header.numberClientsServed")}
                        maxLength={3}
                        value={String(item.quantity)}
                        onChange={e => handleChangeQuantity(index, String(e))}
                        inputComponent={NumberFormatBase}
                      />}
                  ></ListItem>)
              })
            }
          </>}
        />

        <div className="closingSalesSaveButton">
          <Button onClick={onSaveServedClients} disabled={saveDisable}>{t("header.save")}</Button>
        </div>
      </div>

    </>
  );
}